module.exports = __webpack_public_path__ + "static/ryma-5976cb09f4fb5eb2430b7f99867c50e0.png";